/**
 * Customizations for Smartling
 */

jQuery( document ).ready( function( $ ){
	// Remove WP Admin bar on smartling proxies.
	if ($( 'body' ).is( '[class*="smartling-"]' )) {
		$( '#wpadminbar' ).hide();
		$( this ).removeClass( 'admin-bar logged-in' );
		$('html').css({'margin-top':'0'});
	}
});
